// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3NSDT","header":"ReportDetails_header__1NyuU","title":"ReportDetails_title__3j6sM","left":"ReportDetails_left__fdxM1"};